import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import CampOperatorApi from './CampOperatorApi';
import CampOperatorActions from './Components/CampOperatorActions';

let settings;

export default settings = {
    key: 'camp/operators',
    zone: 'camp',
    path: '/camp/operators',
    title: "Camp Operator",
    endpoint: CampOperatorApi.endpoint,
    modelName: 'CampOperator',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewCampOperator"],
    viewCaps: ["viewCampOperator"],
    createCaps: ["createCampOperator"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All Operators",
                path: settings.path
            },
            // {
            //     label: "Draft",
            //     path: settings.path + "/status/draft",
            // },
            // {
            //     label: "Preview",
            //     path: settings.path + "/status/preview",
            // },
            // {
            //     label: "Publish",
            //     path: settings.path + "/status/publish",
            // },
            // {
            //     label: "Archive",
            //     path: settings.path + "/status/archive",
            // },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: CampOperatorApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ["host"], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <CampOperatorActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: CampOperatorApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ["host"] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};